import { useSetAtom } from 'jotai';
import * as state from '@/components/Analysis/state';
import {
  POI_MARKER_LABEL_BACKGROUND_COLOR,
  POI_MARKER_LABEL_WHITE_BACKGROUND_COLOR,
} from '@/theme/colors';

export const usePoiLabelMarkerColors = () => {
  const setPoiLabelMarkerBackgroundColor = useSetAtom(state.poiMarkerLabelBgColor);
  const setPdfPoiLabelMarkerColors = () => {
    setPoiLabelMarkerBackgroundColor(POI_MARKER_LABEL_WHITE_BACKGROUND_COLOR);
  };

  const resetPoiLabelMarkerColors = () => {
    setPoiLabelMarkerBackgroundColor(POI_MARKER_LABEL_BACKGROUND_COLOR);
  };
  return {
    setPdfPoiLabelMarkerColors,
    resetPoiLabelMarkerColors,
  };
};
